import { render, staticRenderFns } from "./BaseBackoffice.vue?vue&type=template&id=ea6bed5c"
import script from "./BaseBackoffice.vue?vue&type=script&lang=js"
export * from "./BaseBackoffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports